export default class Storage {
  constructor(prefix) {
    if (typeof prefix !== 'string') throw new Error('"prefix" should be a string');
    this._prefix = prefix;
  }

  getKey(key = '') {
    if (typeof key !== 'string') throw new Error('"key" should be a string');
    return this._prefix ? `${this._prefix}_${key}` : key;
  }

  get(key, defaultValue) {
    const stringValue = localStorage.getItem(this.getKey(key));
    return stringValue !== null ? JSON.parse(stringValue) : defaultValue;
  }

  set(key, value) {
    if (typeof value === 'function') throw new Error('"value" could not be a function');
    if (value === undefined) this.remove(key);
    else localStorage.setItem(this.getKey(key), JSON.stringify(value));
  }

  remove(key) {
    localStorage.removeItem(this.getKey(key));
  }

  clear() {
    Object.keys(localStorage).forEach(key => {
      if (key.indexOf(this.getKey()) === 0) {
        localStorage.removeItem(key);
      }
    });
  }
}
